import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import PageTitle from 'components/_base/PageTitle';

import ContentAdminUsuarios from './ContentAdminUsuarios';

const App = () => {
  return (
    <>
      <HeaderApp />
      <div className="panel">
        <PageTitle title="Usuários" />
        <hr />
        <ContentAdminUsuarios />
      </div>
      <Bottom />
    </>
  );
};

export default App;
